import { render } from "./index.vue?vue&type=template&id=65eabe6c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=65eabe6c&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=65eabe6c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65eabe6c"]])

export default __exports__